import { useEffect } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { WhyPluk } from "../components/WhyPluk";
import { Focus } from "../components/Focus";
import { TalentMap } from "../components/TalentMap";
import { Lens } from "../components/Lens";
import { Process } from "../components/Process";
import { Models } from "../components/Models";
import { MandateForm } from "../components/MandateForm";
import { ParentBrand } from "../components/ParentBrand";
import { Footer } from "../components/Footer";
import { SmoothScroll, scrollToId } from "../components/SmoothScroll";

export default function Landing() {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="grain relative overflow-x-clip" data-testid="landing-page">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <About />
        <Models />
        <Focus />
        <TalentMap />
        <Lens />
        <Process />
        <WhyPluk />
        <MandateForm />
        <ParentBrand />
      </main>
      <Footer />
    </div>
  );
}
